import { modifyLabHospitalMapping, syncLabHospitalTariffsToBilling } from '@/modules/lab/api/labOperationalMasterApi'
import type { CatalogInvestigationRow } from '@/modules/lab/catalog/types'

export function isPricingPending(row: CatalogInvestigationRow): boolean {
  return row.hospitalEnabled && (row.tariffAmount == null || row.tariffAmount <= 0)
}

export function isBillableReady(row: CatalogInvestigationRow): boolean {
  return row.hospitalEnabled && row.tariffAmount != null && row.tariffAmount > 0
}

export async function setHospitalTariff(
  row: CatalogInvestigationRow,
  tariffAmount: number,
  enabledFlag = true,
): Promise<void> {
  if (!row.mappingId) {
    throw new Error(`${row.displayName} is not enabled at this hospital.`)
  }
  if (!Number.isFinite(tariffAmount) || tariffAmount <= 0) {
    throw new Error('Tariff amount must be greater than zero.')
  }
  await modifyLabHospitalMapping({
    mappingId: row.mappingId,
    investigationMasterId: row.investigationMasterId,
    billingServiceId: row.billingServiceId,
    enabledFlag,
    activeFlag: 'A',
    localCode: row.localCode ?? '',
    localDisplayName: row.localDisplayName ?? '',
    tariffAmount,
  })
}

export async function bulkSetHospitalTariffs(
  rows: CatalogInvestigationRow[],
  tariffAmount: number,
): Promise<{ ok: number; failed: number; errors: string[] }> {
  let ok = 0
  let failed = 0
  const errors: string[] = []
  for (const row of rows) {
    if (!row.hospitalEnabled || !row.mappingId) {
      failed++
      errors.push(`${row.displayName}: not enabled`)
      continue
    }
    try {
      await setHospitalTariff(row, tariffAmount)
      ok++
    } catch (e) {
      failed++
      errors.push(`${row.displayName}: ${e instanceof Error ? e.message : 'failed'}`)
    }
  }
  return { ok, failed, errors }
}

export async function syncAllHospitalTariffsToBilling(): Promise<number> {
  const result = await syncLabHospitalTariffsToBilling()
  return result?.synced ?? 0
}
